'use client';

import { createFileRoute } from '@tanstack/react-router';

import { RiskHeatmap } from '@/features/rsk/components/RiskHeatmap';
import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/risks/heatmap')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.riskRegister', { defaultValue: 'Risk heatmap' }),
  }),
  component: RiskHeatmapPage,
});

function RiskHeatmapPage() {
  return (
    <div className="p-8">
      <div className="mx-auto max-w-7xl">
        {/*
          TODO(WP4-B): Render <GroupScopePill /> adjacent to the heatmap title
          once `useRiskHeatmap` exposes rollup scope metadata. Backend
          `RiskHeatmapResponse` already inherits `RollupScopeMixin`, but the
          hook does not propagate those fields and the query key lacks the
          required `organizationId` element (see
          `docs/subsidiary-refactor/MIGRATION-GUIDE.md` Step 5). Skipped until
          the hook is brought in line with the canonical contract.
        */}
        <RiskHeatmap />
      </div>
    </div>
  );
}
